import {
  Component,
  OnInit,
  Inject,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ViewContainerRef,
  TemplateRef,
} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AngularEditorConfig } from "@kolkov/angular-editor";
import { icons } from "src/app/shared-data/common-arrays";
import { ModuleService } from "src/app/services/module.service";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { FormControl } from "@angular/forms";
import {MatDialog as MatDialog, DialogPosition as DialogPosition,MatDialogConfig as MatDialogConfig, MAT_DIALOG_DATA as MAT_DIALOG_DATA,MatDialogRef as MatDialogRef } from "@angular/material/dialog";
import {MatSnackBar as MatSnackBar } from "@angular/material/snack-bar";
import { MediaDialogComponent } from "src/app/new-media/new-media-manager/media-dialog/media-dialog.component";

@Component({
  selector: "app-add-edit-menu",
  templateUrl: "./add-edit-menu.component.html",
  styleUrls: ["./add-edit-menu.component.css"],
})
export class AddEditMenuComponent implements OnInit {
  @Input() data: any;
  @Input() parentMenus: any;
  @Output() result = new EventEmitter<any>();
  @ViewChild("content", { read: ViewContainerRef, static: true })
  content: ViewContainerRef;
  @ViewChild("menuName", { static: true })
  menuName: any = "";
  tempMenu: any = {};
  allPages: any[] = [];
  pages: any[] = [];
  searchText = "";
  filterText = "";
  tempMeta: any = {};
  addEditMenu: boolean = false;
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: "auto",
    minHeight: "300px",
  };

  icons: any[] = icons;
  allTemplates: any[] = [];
  icon: any[] = icons;
  viewGallery: boolean;
  indexToEdit: number = null;

  options: any = {
    autogrow: true,
    removeformatPasted: true,
    semantic: false,
  };
  menus: any[] = [];
  categoriesList: any = new FormControl();
  categories: any[] = [];
  posts: any[] = [];
  loadData: boolean = false;
  modalPost: BsModalRef;
  modalRef: BsModalRef;
  modalCategory: BsModalRef;
  @Input() menuLength: number;

  constructor(
    private httpClient: HttpClient,
    private moduleService: ModuleService,
    private modalService: BsModalService,
    public dialog: MatDialog
  ) { }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: "modal-lg" });
  }

  postModal(template: TemplateRef<any>) {
    this.modalPost = this.modalService.show(template, { class: "modal-lg" });
  }
  categoryModal(template: TemplateRef<any>) {
    this.modalPost = this.modalService.show(template, { class: "modal-lg" });
  }
  ngAfterViewInit() {
    // this.menuName.nativeElement.focus();
  }

  ngOnInit() {

    this.GetAllPages();
    this.GetAllTemplates();
    this.GetCategories();
    this.tempMenu = JSON.parse(JSON.stringify(this.data));
    this.tempMenu.thumbnailURL = this.tempMenu.thumbnailURL;
    this.tempMenu.templateId = this.tempMenu.templateId || 0;
    this.tempMenu.menuType = this.tempMenu.menuType || 5;
    this.tempMenu.externalSlug = this.tempMenu.menuType == 1 ? this.tempMenu.slug : '';
    this.tempMenu.slug = this.tempMenu.menuType == 2 ? this.tempMenu.slug : '';
    this.tempMenu.postSlug = this.tempMenu.postSlug
      ? this.tempMenu.postSlug
      : "";
    this.tempMenu.orgSlug = this.tempMenu.slug ? this.tempMenu.slug : "";
    this.tempMenu.slugError = "";
    this.tempMenu.content = this.tempMenu.content || "";
    this.tempMenu.parentId = this.tempMenu.parentId || "";
    this.tempMenu.addtionalMetaTags = this.tempMenu.addtionalMetaTags
      ? JSON.parse(this.tempMenu.addtionalMetaTags)
      : [];
    this.categoriesList.value = this.categoriesList.value || [];
  }
  AddMeta() {
    if (this.indexToEdit == null)
      this.tempMenu.addtionalMetaTags.push(this.tempMeta);
    else
      this.tempMenu.addtionalMetaTags[this.indexToEdit] = JSON.parse(
        JSON.stringify(this.tempMeta)
      );
    this.indexToEdit = null;
    this.tempMeta = {};
  }

  editMeta(m, i) {
    console.log('perant',m, i)
    this.tempMeta = JSON.parse(JSON.stringify(m));
    this.indexToEdit = i;
  }

  GetAllTemplates() {
    this.httpClient
      .get("/PageTemplate/GetAllPageTemplates")
      .subscribe((res: any) => {
        for (let i = 0; i < res.length; i++) {
          const element = res[i];
          if (element.type == 2) {
            this.allTemplates.push(element);
          }
        }
      });
  }

  CheckSiteSlug(slug) {
    if (slug && slug != this.tempMenu.orgSlug) {
      this.tempMenu.slugError = "checking..";
      this.httpClient
        .get("/General/CheckSiteSlug/" + slug, { responseType: "text" })
        .subscribe((res: any) => {
          if (res != "ok") {
            this.tempMenu.slugError = res;
          } else this.tempMenu.slugError = "";
        });
    } else this.tempMenu.slugError = "";
  }

  getPageName(id) {
    if (id) {
      for (let i = 0; i < this.allPages.length; i++) {
        const e = this.allPages[i];
        if (e.id == id) {
          return e.name;
        }
      }
    } else return null;
  }

  close() {
    this.result.emit(0);
  }

  save(form) {
    if (form.invalid || this.tempMenu.slugError != "") {
      Object.keys(form.controls).forEach((feild) => {
        form.controls[feild].markAsTouched(true);
      });
      return;
    }

    var data = JSON.parse(JSON.stringify(this.tempMenu));

    data.templateId =
      data.templateId != 0 && data.type == 4 ? +data.templateId : undefined;

    data.addtionalMetaTags = JSON.stringify(data.addtionalMetaTags) || null;

    if (data.id) {
      //  data.order = (data.order) ? data.order : data.id;
      this.httpClient
        .post("/Menus/EditMenu/" + data.id, data)
        .subscribe((res: any) => {
          this.result.emit(data);
        });
    } else {
      //  data.order = (this.menuLength) ? this.menuLength + 1 : 0;
      data.status = 1;
      this.httpClient.post("/Menus/AddMenu", data).subscribe((res: any) => {
        this.result.emit(data);
      });
    }
  }

  GetAllPages() {
    this.allPages = [];
    this.httpClient.post("/Pages/GetAllPages",{}).subscribe((res: any) => {
      for (let index = 0; index < res.length; index++) {
        const element = res[index];
        if (element.status == 2) {
          this.allPages.push(element);
          this.pages = this.allPages;
        }
      }
      // this.allPages = res;
      // this.pages = this.allPages;
    });
  }

  FilterPages() {
    this.pages = [];
    if (this.filterText != "") {
      this.allPages.forEach((element) => {
        if (
          element.name.toUpperCase().indexOf(this.filterText.toUpperCase()) >= 0
        ) {
          this.pages.push(element);
        }
      });
    } else {
      this.pages = this.allPages;
    }
  }

  FilterIcons() {
    this.icon = [];
    if (this.searchText != "") {
      this.icons.forEach((element) => {
        if (
          element.value.toUpperCase().indexOf(this.searchText.toUpperCase()) >=
          0
        ) {
          this.icon.push(element);
        }
      });
    } else {
      this.icon = this.icons;
    }
  }

  openGallery() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.position = { top: "0px", right: "0px" };
    dialogConfig.height = "100vh";
    dialogConfig.width = "50vw";
    dialogConfig.panelClass = "media-modal";
    dialogConfig.data = { isMultiSelect: false ,files: ["image",'webp']};

    let dialogRef = this.dialog.open(MediaDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.tempMenu.thumbnailId = result.id;
        this.tempMenu.thumbnailURL = result.publicUrl;
      }
    });

    // var x = this.moduleService.ComponentFactory['GalleryComponent'];
    // if (this.moduleService.ComponentFactory['GalleryComponent']) {
    //   this.viewGallery = true
    //   this.content.clear();
    //   // create setting component
    //   const component: any = this.content.createComponent(x);
    //   // sending @Input() values
    //   component.instance.data = { enviroment: window['config'] };
    //   //  save @output()
    //   component.instance.imgUrl.subscribe(res => {
    //     if (res && res != null) {
    //       this.tempMenu.image = window['config'].apiUrl + '/' + res.publicUrl
    //       while (this.tempMenu.image.indexOf('\\') !== -1) {
    //         this.tempMenu.image = this.tempMenu.image.replace('\\', '/');
    //       }
    //       this.tempMenu.showMenuImage = true
    //     }
    //     this.viewGallery = false
    //     this.content.clear();
    //   });

    // }
  }
  updateSlug() {
    const a =
      "àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;";
    const b =
      "aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnooooooooprrsssssttuuuuuuuuuwxyyzzz------";
    const p = new RegExp(a.split("").join("|"), "g");
    if (this.tempMenu.slug == "" && this.tempMenu.name) {
      this.tempMenu.slug = this.tempMenu.name
        .toString()
        .toLowerCase()
        .replace(/\s+/g, "-") // Replace spaces with -
        .replace(p, (c) => b.charAt(a.indexOf(c))) // Replace special characters
        .replace(/&/g, "-and-") // Replace & with 'and'
        .replace(/[^\w\-]+/g, "") // Remove all non-word characters
        .replace(/\-\-+/g, "-") // Replace multiple - with single -
        .replace(/^-+/, "") // Trim - from start of text
        .replace(/-+$/, ""); // Trim - from end of text;
    }
  }
  slugifyString(str) {
    const a =
      "àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;";
    const b =
      "aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnooooooooprrsssssttuuuuuuuuuwxyyzzz------";
    const p = new RegExp(a.split("").join("|"), "g");
    if (str) {
      return str
        .toString()
        .toLowerCase()
        .replace(/\s+/g, "-") // Replace spaces with -
        .replace(p, (c) => b.charAt(a.indexOf(c))) // Replace special characters
        .replace(/&/g, "-and-") // Replace & with 'and'
        .replace(/[^\w\-]+/g, "") // Remove all non-word characters
        .replace(/\-\-+/g, "-") // Replace multiple - with single -
        .replace(/^-+/, "") // Trim - from start of text
        .replace(/-+$/, ""); // Trim - from end of text;
    }
  }
  // posts

  fillCategories(categoryId) {
    if (categoryId.value.length != 0) {
      this.categoriesList.value;
    }
  }
  GetCategories() {
    this.httpClient
      .get("/Categories/GetCategoriesByTypeId/7")
      .subscribe((res: any) => {
        this.categories = res ? res : [];
        if (this.categoriesList.value.length > 0) {
          this.getPosts(this.categoriesList.value);
        }
      });
  }
  GetAllCategories(){
    this.httpClient
      .get("/Categories/GetCategoriesByTypeId/2")
      .subscribe((res: any) => {
        this.categories = res ? res : [];
        if (this.categoriesList.value.length > 0) {
          this.getCats(this.categoriesList.value);
        }
      });
  }
  getCats(ids){

  }
  getPosts(ids) {
    this.httpClient
      .get(`/BolgArchive/GetPosts/0/1/100/${ids}`)
      .subscribe((res: any) => {
        this.posts = res.PostsList;
      });
  }
  getPostByCategoryId(categoryId) {
    var ids = [];
    for (let i = 0; i < categoryId.length; i++) {
      const element = categoryId[i];
      ids.push(element.id);
    }
    this.httpClient
      .get(`/BolgArchive/GetPosts/0/1/100/${ids}`)
      .subscribe((res: any) => {
        this.posts = res.PostsList;
      });
  }

  getThumbnailUrl(item) {
    if (item.mediaURLs.length)
      return window["config"].apiUrl + "/" + item.mediaURLs[0].url;
    else return "";
  }
}
